<script>
export default {
  name: "MyFooter"
}
</script>

<template>
  <!--    底部栏-->
  <div class="w-screen bg-coffeeBg flex flex-col items-center text-white py-10 text-white">
    <img src="@/assets/coffee-logo.png" alt="" class="w-52 h-44">
<!--    <div class="flex mt-5">-->
<!--      <div class="text-center mx-3">-->
<!--        <img src="@/assets/qrCode/qr.png" alt="" class="w-24">-->
<!--        <p class="mt-2 text-sm">Facebook</p>-->
<!--      </div>-->
<!--      <div class="text-center mx-3">-->
<!--        <img src="@/assets/qrCode/qr.png" alt="" class="w-24">-->
<!--        <p class="mt-2 text-sm">Instagram</p>-->
<!--      </div>-->
<!--      <div class="text-center mx-3">-->
<!--        <img src="@/assets/qrCode/qr.png" alt="" class="w-24">-->
<!--        <p class="mt-2 text-sm">微信公众号</p>-->
<!--      </div>-->
<!--    </div>-->
    <div class="flex items-center mt-5">
      <p class="px-5 cursor-pointer hover:text-coffeeLight transition" @click="$router.push('/coffee/disclaimer')">
        {{ $t('footer.disclaimer') }}</p>
      <p class="border-r border-l px-5 cursor-pointer hover:text-coffeeLight transition"
         @click="$router.push('/coffee/use')">{{ $t('footer.use') }}</p>
      <p class="px-5 cursor-pointer hover:text-coffeeLight transition" @click="$router.push('/coffee/desc')">
        {{ $t('footer.desc') }}</p>
    </div>
    <p class="mt-5">© {{ new Date().getFullYear() }} {{$t('footer.company')}}</p>
  </div>
</template>

<style scoped>

</style>